import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelivery = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4384 5H7.56155C6.64382 5 5.84385 5.62459 5.62127 6.51493L5.05971 8.76114C5.02005 8.91978 5 9.08269 5 9.24621V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V9.24621C19 9.08269 18.9799 8.91978 18.9403 8.76114L18.3787 6.51493C18.1561 5.62459 17.3562 5 16.4384 5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 5H10L9.05971 8.76114C9.02005 8.91978 9 9.08269 9 9.24621V12.5H15V9.24621C15 9.08269 14.9799 8.91978 14.9403 8.76114L14 5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 16L16 16",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9L19 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDelivery);
export default ForwardRef;
